var map = {
	"./audit.svg": "e9b3",
	"./configuration.svg": "314a",
	"./goods.svg": "2231",
	"./home.svg": "ac9d",
	"./jibenxinxi.svg": "a12a",
	"./marketing.svg": "6aa5",
	"./order.svg": "2965"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";